import { SelectOption } from '@/const/types'

//used for Degree Year Options
export const generateYearOptions = (): SelectOption<string>[] => {
	const currentYear = new Date().getFullYear()
	const yearsBack = 60

	return Array.from({ length: yearsBack + 1 }, (_, i) => {
		const year = String(currentYear - i)
		return { label: year, value: year }
	})
}

export const generateYearOptionsForDateOfBirth = (): SelectOption<number>[] => {
	const currentYear = new Date().getFullYear()
	const yearsBack = 120

	return Array.from({ length: yearsBack + 1 }, (_, i) => {
		const year = currentYear - i
		return { label: String(year), value: year }
	})
}

// used for Date of Birth Year Options
export const generateDOBYearOptions = (): SelectOption[] => {
	const currentYear = new Date().getFullYear()
	const yearsBack = 120

	return Array.from({ length: yearsBack + 1 }, (_, i) => {
		const year = String(currentYear - i)
		return { label: year, value: year }
	})
}

// used for Date of Birth Year Options
export const generateDOB18 = (): SelectOption[] => {
	const currentYear = new Date().getFullYear()
	const startYear = currentYear - 18
	const endYear = currentYear - 120

	return Array.from({ length: startYear - endYear + 1 }, (_, i) => {
		const year = String(startYear - i)
		return { label: year, value: year }
	})
}
